import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { Component } from 'react';

class AvailableVacationRow extends Component {
    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Munkavállaló</TableCell>
                            <TableCell>Év</TableCell>
                            <TableCell>Napok száma</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key="new">
                            <TableCell>{this.props.row.employeeName}</TableCell>
                            <TableCell>{this.props.row.year}</TableCell>
                            <TableCell>{this.props.row.availableDays}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
export default AvailableVacationRow;